import { Seo } from "components/Seo";
import GetCompany from "./GetCompany";
import NoCompany from "./NoCompany";

const haveCompany: boolean = true;

const MyAccount = () => {
  return (
    <>
      <Seo title="Min konto" />
          {haveCompany?(
            <GetCompany />
          ):(
            <NoCompany />
          )}
    </>
  );
};

export default MyAccount;
